import { useCallback, useEffect, useState } from "react";
import * as API from "../../api";
import { toast } from "react-toastify";
import { usePermissions } from "../../context";
import { TABS } from "./constants.js";
import { handleDownload } from "../../utils";

import { devLogger } from  "../../helpers/devlogger"

import {
  EngagedSectionComponent,
  BillableSectionComponent,
  ListSectionComponent,
} from "./sections.jsx";
import {
  METADATA_CREAR_COMPROMETIDO,
  METADATA_VISUALIZAR_EDITAR_COMPROMETIDO,
} from "../../constants/index.js";

import {ionPartidasService} from "../../api/services/ionPartidasService"

const {getFamiliasFromIONPartidas, getConceptosByFamilia}  = ionPartidasService()

const useIONEngagedPage = () => {
  const { permissions } = usePermissions();
  const [area, setArea] = useState("");
  const [exercise, setExercise] = useState("");
  const [engagedFormData, setEngagedFormData] = useState({});
  const [
    cargarArchivoComprometidoRevisado,
    setCargarArchivoComprometidoRevisado,
  ] = useState({});
  const [disabledApplyBTN, setDisabledApplyBTN] = useState(true);
  const [disabledLoadExpensesTemplateBTN, setDisabledLoadExpensesTemplateBTN] =
    useState(true);
  const [accessEngagedSection, setAccessEngagedSection] = useState(false);
  const [accessBillabeSection, setAccessBillableSection] = useState(false);
  const [accessListSection, setAccessListSection] = useState(false);
  const [loading, setLoading] = useState(false);


  const listEmptyValue = {
    value: "",
    label: ""
  }
  
  const [suplier, setSuplier] = useState({ value: "", label: "" });
  const [suplierFilter, setSuplierFilter] = useState({ value: "", label: "" });
  const [registers, setRegisters] = useState([]);
  const [businessUnitList, setBusinessUnitList] = useState([]);
  const [businessSelected, setBussinesSelected] = useState({
    value: "",
    label: "",
  });
  const [areaList, setAreaList] = useState([]);
  const [areaSelected, setAreaSelected] = useState({ value: "", label: "" });
  const [exerciseList, setExerciseList] = useState([]);
  const [exerciseSelected, setExerciseSelected] = useState({
    value: "",
    label: "",
  });
  const [stateOT, setStateOT] = useState({
    value: "",
    label: "",
  });
  const [stateOTList, setStateOTList] = useState([]);
  const [numberOT, setNumberOT] = useState("");
  const [sociedad, setSociedad] = useState({
    value: "",
    label: "",
  });
  const [sociedadList, setSociedadList] = useState([]);
  const [fecComprDesde, setFecComprDesde] = useState("");
  const [fecComprHasta, setFecComprHasta] = useState("");
  const [facturado, setFacturado] = useState({ value: "" });
  const [validado, setValidado] = useState({ value: "" });
  const [exportado, setExportado] = useState({ value: "" });

  const [page, setPage] = useState(1);
  const [totalStatusSummary, setTotalStatusSummary] = useState([]);
  const [isAdminIon, setIsAdminIon] = useState(false);
  const [isCoordinadorIon, setIsCoordinadorIon] = useState(false);
  const [exportOptions, setExportOptions] = useState({
    PF: false,
    SP: false,
    FD: false,
    NF: false,
    SF: false,
    CDPF: false,
  });
  const [metadataRegisters, setMetadataRegisters] = useState([]);
  const [typeBillable, setTypeBillable] = useState({ value: "", label: "" });
  const [billableDates, setBillableDates] = useState({});
  const [facturable, setFacturable] = useState({ value: "", label: "" });

  const [familiaList, setFamiliaList] = useState([]);
  const [conceptoList, setConceptoList] = useState([]);

  const [familiaSelected, setFamiliaSelected] = useState({ value: "", label: ""});
  const [conceptoSelected, setConceptoSelected] = useState({ value: "", label: ""});
  const [hayFiltroSeleccionado, setHayFiltroSeleccionado] = useState(false);
  const [seleccionFiltro, setSeleccionFiltro] = useState(false);
  const [registrosPorProcesar, setRegistrosPorProcesar] = useState([]);
  const [numeroFacturable, setNumeroFacturable] = useState('');

  // const [recargarDatos, setRecargarDatos] = useState(false);

  const saveIONEngagedFiltersToLocalStorage = () => {
  
    try {
      const filter =  {
              UnidadNegocio: businessSelected ?? listEmptyValue,
              AreaDepartamento: areaSelected ?? listEmptyValue,
              Ejercicio: exerciseSelected ?? listEmptyValue
      };
        
      localStorage.setItem("FiltrosIONComprometidos", JSON.stringify(filter));
      
    } catch (error) {
        devLogger.error("Error al guardar filtros en localStorage:", error)
    }
  };

  
  const loadIONEngagedFiltersFromLocalStorage = () => {
    try {
      const raw = localStorage.getItem("FiltrosIONComprometidos");
      if (!raw) return null;

      const filtro = JSON.parse(raw);

      const isValid =
        filtro?.UnidadNegocio?.value !== undefined &&
        filtro?.AreaDepartamento?.value !== undefined &&
        filtro?.Ejercicio?.value !== undefined;

      if (!isValid) {
        console.warn("Filtros corruptos o incompletos:", filtro);
        return null;
      }

      return {
        UnidadNegocio: filtro.UnidadNegocio ?? listEmptyValue,
        AreaDepartamento: filtro.AreaDepartamento ?? listEmptyValue,
        Ejercicio: filtro.Ejercicio ?? listEmptyValue
      };
    } catch (error) {
      console.error("Error al leer filtros desde localStorage:", error);
      return null;
    }
  };

    
  const handleChangeFamilia = (_, value) => {
    setConceptoSelected({ value: "", label: ""})
    setFamiliaSelected({ value: value.Valor, label: value.Etiqueta })        
  };

  const handleChangeConcepto = (_, value) => {
    setConceptoSelected({ value: value.Valor, label: value.Etiqueta })    
  };

  const showValidarComprometidos = async () => {
    let cantResgistros = 0;
    if (seleccionFiltro){
      // aqui buscamos la cantidad de registros para validar
      cantResgistros = await getCantidadItemsPorProcesar('Validar');
      setMessageAlert(`Hay ${cantResgistros} registros filtrados para validar`);
    } else {
      const resgistros = registers.filter(x => x.seleccionado && x.validar === false);
      setRegistrosPorProcesar(resgistros);
      cantResgistros = resgistros.length;
      setMessageAlert(`Hay ${cantResgistros} registros seleccionados para validar`);
    }
    
    if (cantResgistros > 0){
      setVisibleAlert('Validar');
    } else {
      toast.info("No hay registros seleccionados por validar.");
    }
  }

  const showDesValidarComprometidos = async() => {
    let cantResgistros = 0;
    if (seleccionFiltro){
      // aqui buscamos la cantidad de registros para validar
      cantResgistros = await getCantidadItemsPorProcesar('Desvalidar');
      setMessageAlert(`Hay ${cantResgistros} registros filtrados para desvalidar`);
    } else {
      
      const resgistros = registers.filter(x => x.seleccionado && x.validar === true && x.facturado === false);
      setRegistrosPorProcesar(resgistros);
      cantResgistros = resgistros.length;
      setMessageAlert(`Hay ${cantResgistros} registros seleccionados para desvalidar`);
    }

    if (cantResgistros > 0){
      setVisibleAlert('Desvalidar');
    } else {
      toast.info("No hay registros seleccionados por desvalidar.");
    }
  }

  const showFacturarComprometidos = async() => {
    let cantResgistros = 0;
    if (seleccionFiltro){
      // aqui buscamos la cantidad de registros para validar
      cantResgistros = await getCantidadItemsPorProcesar('Facturar');
      setMessageAlert(`Hay ${cantResgistros} registros filtrados para facturar`);
    } else {
      const resgistros = registers.filter(x => x.seleccionado && x.facturado === false);
      setRegistrosPorProcesar(resgistros);
      cantResgistros = resgistros.length;
      setMessageAlert(`Hay ${cantResgistros} registros seleccionados para facturar`);
    }
    
    if (cantResgistros > 0){
      setVisibleAlert('Facturar');
    } else {
      toast.info("No hay registros seleccionados por facturar.");
    }
  }

  const showExportarComprometidos = async() => {
    let cantResgistros = 0;
    if (seleccionFiltro){
      // aqui buscamos la cantidad de registros para validar
      cantResgistros = await getCantidadItemsPorProcesar('Exportar');
      setMessageAlert(`Hay ${cantResgistros} registros filtrados para exportar`);
    } else {
      const resgistros = registers.filter(x => x.seleccionado && x.facturado === true && x.exportado === false);
      setRegistrosPorProcesar(resgistros);
      cantResgistros = resgistros.length;
      setMessageAlert(`Hay ${cantResgistros} registros seleccionados para exportar`);
    }
    
    if (cantResgistros > 0){
      setVisibleAlert('Exportar');
    } else {
      toast.info("No hay registros seleccionados por exportar.");
    }
  }
  
  const LIST_SIZE = 20;
  const listTypeFacturable = {
    Lista: "TipoFacturableLista",
    MasFilas: false,
    MostrarVacio: 0,
    Valores: [
      { value: "PF", label: "Prefacturas PF" },
      { value: "SP", label: "Suplidos SP" },
      { value: "FD", label: "Factura Directa FD" },
      { value: "NF", label: "No Facturable NF" },
      { value: "SF", label: "Sin Factura SF" },
    ],
  };

  const listFacturable = {
    Lista: "FacturableLista",
    MasFilas: false,
    MostrarVacio: true,
    Valores: [
      { value: true, label: "Si" },
      { value: false, label: "No" },
    ],
  };
  const [modalRequest, setModalRequest] = useState("");
  const [visibleModal, setVisibleModal] = useState("");
  const [visibleAlert, setVisibleAlert] = useState("");
  const [messageAlert, setMessageAlert] = useState("");
  const [selected, setSelected] = useState("");
  const [comprometido, setComprometido] = useState({});
  const [comprometidoOriginal, setComprometidoOriginal] = useState({});
  const [listsModalComprometido, setListsModalComprometido] = useState([]);

  const [metadataTable, setMetadataTable] = useState([]);
  useEffect(() => {
    switch (visibleModal) {
      case "cargarComprometido":
        return setMetadataTable(METADATA_CREAR_COMPROMETIDO);

      case "editarComprometido":
      case "visualizarComprometido":
        return setMetadataTable(METADATA_VISUALIZAR_EDITAR_COMPROMETIDO);
      default:
        return [];
    }
  }, [visibleModal]);

  useEffect(() => {
    setLoading(true);
    API.obtenerListas("IONComprometido")
      .then((res) => {
        if (area) {
          Promise.all([
            API.obtenerFamiliaPorArea(area)
              .then(
                (resFam) =>
                  (res["Familia"] = {
                    Valores: resFam,
                    Lista: "Familia",
                    MostrarVacio: 0,
                    MasFilas: false,
                  })
              )
              .catch((error) => console.error(error)),
            API.obtenerLista({ Lista: "AreaComprometidos" })
              .catch((error) => { console.error(error); return null; }),
          ]).then(([, areaListRes]) => {
            const idCliente = areaListRes?.Valores?.find((x) => x.Valor === area)?.IdEntidadRelacional;
            const sociedadesFiltradas = res["SociedadAuxiliar"].Valores.filter(
              (x) => x.IdEntidadRelacional === idCliente
            );
            res["SociedadAuxiliar"].Valores = sociedadesFiltradas;
            setListsModalComprometido(res);
          });
        } else {
          setListsModalComprometido(res);
        }
      })
      .catch((error) => console.error(error));

    if (
      ["visualizarComprometido", "editarComprometido"].includes(modalRequest)
    ) {
      API.obtenerComprometido(selected)
        .then((res) => {
          res.Proveedor = {
            Valor: res.CodigoProveedor,
            Etiqueta: res.Proveedor,
          };
          setComprometido(res);
          setComprometidoOriginal(res);
        })
        .catch((error) => {
          if (error.code !== 401)
            toast.error(
              "Error al obtener tabla resumen: " + error.msg?.Message
            );
          API.DEVELOP && console.log(error);
        })
        .finally(() => {
          setVisibleModal(modalRequest);
        });
    } else {
      setVisibleModal(modalRequest);
    }
    setLoading(false);
  }, [modalRequest, selected, area]);

  useEffect(() => {
    if (
      modalRequest === "visualizarComprometido" ||
      modalRequest === "editarComprometido"
    ) {
      setMetadataTable(METADATA_VISUALIZAR_EDITAR_COMPROMETIDO);
    }

    if (modalRequest === "cargarComprometido") {
      setMetadataTable(METADATA_CREAR_COMPROMETIDO);
    }
  }, [modalRequest]);

  useEffect(() => {    
    loadConceptoList(familiaSelected.value || []);
  }, [familiaSelected]);

  const validarCampos = (data) => {
    let mensajeError = "Faltan campos requeridos (*):\n";
    let error = false;
    let resultado = false;
    metadataTable
      .filter((m) => m.requerido)
      .forEach((e) => {
        if (
          comprometido.PermiteEditarImporteBaja &&
          e.nombreCampo === "ImporteRevisado" &&
          Number(data[e.nombreCampo]) >
            Number.parseFloat(comprometidoOriginal[e.nombreCampo]) &&
            exerciseSelected.label.includes("Cerrado")
        ) {
          error = true;
          mensajeError = "El importe no puede ser mayor que el actual";
        } else if (!data[e.nombreCampo] && data[e.nombreCampo] !== 0) {
          if (e.tipo === "checkbox") {
            data[e.nombreCampo] = "NO";
          } else {
            mensajeError += `${e.etiqueta}\n`;
            error = true;
          }
        }
      });
    if (error) {
      resultado = mensajeError;
    }
    return resultado;
  };

  const validarCamposProrrateo = (data) => {
    const prorrateo = data["Prorrateo"];
    const fechaInicio = data["FechaInicioProrrateo"];
    const meses = data["MesesProrrateo"];

    // Si prorrateo no es "SI", se considera válido por defecto (no aplica validación)
    if (prorrateo !== "SI") return '';

    // Validar que la fecha no esté vacía y sea una fecha válida
    const fechaValida = fechaInicio && !isNaN(Date.parse(fechaInicio));

    // Validar que los meses sean un número mayor a 0
    const mesesValidos = meses !== null && meses !== undefined && Number.isInteger(Number(meses)) && Number(meses) > 0;
    return fechaValida && mesesValidos ? '' : "Para prorrateo 'SI', la fecha de inicio y los meses deben ser válidos.";
  };

  const editComprometido = (data) => {
    const mensajeError = validarCampos(data);
    if (mensajeError) {
      toast.info(mensajeError);
      return;
    }

    const mensajeErrorProrrateo = validarCamposProrrateo(data);
    if (mensajeErrorProrrateo !== '') {
      toast.info(mensajeErrorProrrateo);
      return;
    }

    metadataTable
      .filter((e) => e.tipo === "checkbox")
      .forEach((e) => {
        if (["False", "True"].includes(data[e.nombreCampo])) {
          data[e.nombreCampo] = data[e.nombreCampo] === "False" ? "NO" : "SI";
        }
      });

    const completeData = structuredClone(data);
      completeData.Proveedor = data.Proveedor.Etiqueta;

      setLoading(true);
      console.log('completeData', completeData);
      API.editarComprometido(completeData)
        .then((res) => {
          if (res?.Estado === "OK") {
            toast.success("Se ha modificado el comprometido");
            getRegisters();
            loadEngagedSummary();
            cerrarModal();
          } else {
            toast.info(res.Mensaje);
          }
        })
        .catch((error) => {
          if (error.code !== 401)
            toast.error(
              "Error al modificar comprometido " + error.msg?.Message
            );
          API.DEVELOP && console.log(error);
        })
        .finally(() => setLoading(false));
  };

  const addComprometido = async (data) => {
    console.log(data);
    const mensajeError = validarCampos(data);
    if (mensajeError) {
      toast.info(mensajeError);
      return;
    }

    const mensajeErrorProrrateo = validarCamposProrrateo(data);
    if (mensajeErrorProrrateo !== '') {
      toast.info(mensajeErrorProrrateo);
      return;
    }

    const area = await API.obtenerAreaPorId(areaSelected.value);
    const completeData = structuredClone(data);
    completeData.UnidadNegocio = businessSelected.label;
    completeData.AreaDepartamento = areaSelected.label;
    completeData.IdArea = areaSelected.value;
    completeData.Ejercicio = exerciseSelected.value;
    completeData.Proveedor = data.Proveedor.Etiqueta;
    completeData.Cliente = area?.idCliente === 1 ? "ALISEDA" : "ANTICIPA";

    setLoading(true);
    API.crearComprometido(completeData)
      .then((res) => {
        if (res?.Estado === "OK") {
          toast.success("Se ha añadido el comprometido");
          getRegisters();
          loadEngagedSummary();
          cerrarModal();
        } else {
          toast.info(res.Mensaje);
        }
      })
      .catch((error) => {
        if (error.code !== 401)
          toast.error("Error al añadir comprometido " + error.msg?.Message);
        API.DEVELOP && console.log(error);
      })
      .finally(() => setLoading(false));
  };

  const deleteComprometido = (data) => {
    setLoading(true);
    API.anularComprometido(data)
      .then((res) => {
        if (res?.Estado === "OK") {
          toast.success("Se ha borrado el comprometido con ot " + data);
          getRegisters();
          loadEngagedSummary();
        } else {
          toast.info(res.Mensaje);
        }
      })
      .catch((error) => {
        if (error.code !== 401)
          toast.error("Error al eliminar comprometido " + error.msg?.Message);
        API.DEVELOP && console.log(error);
      })
      .finally(() => {
        cerrarModal();
        setLoading(false);
      });
  };

  const cerrarModal = () => {
    setModalRequest("");
    setSelected("");
    setComprometido({});
  };

  const cerrarModalAlert = () => {
    setVisibleAlert("");
  };

  const procesarSeleccion = async() => {
    setVisibleAlert("");
    setLoading(true);
    if (seleccionFiltro){
      const data = getFiltrosSeleccionados(visibleAlert);
      const res = await API.procesarComprometidosFiltrados(data);
      if (res.FicheroData) handleDownload(res);
    } else {
      const data = { 
        Tipo: visibleAlert, 
        OTs: registrosPorProcesar.map(x => x.ot), 
        Ejercicio: parseInt(exerciseSelected.value),
        IdArea: areaSelected.value 
      };
      const res = await API.procesarComprometidosSeleccionados(data);
      if (res.FicheroData) handleDownload(res);
    }
    setLoading(false);
    setSeleccionFiltro(false)
    getRegisters();
    toast.success("Registros procesados exitosamente");
  };

  /** Carga el resumen de comprometidos y actualiza los states correspondientes: */
  const loadEngagedSummary = useCallback(() => {

    const filters = loadIONEngagedFiltersFromLocalStorage
  
    const payloadData = {
      Ejercicio: parseInt(exerciseSelected.value) || 0,
      AreaDepartamento: areaSelected.value
    };

    setLoading(true);
    API.obtenerResumen(payloadData)
      .then((res) => {        

        setTotalStatusSummary(res.ResumenComprometidos);
        setIsAdminIon(res.EsAdministradorION);
        setIsCoordinadorIon(res?.EsCoordinadorION);

        const hasPF = res.ResumenComprometidos.some(
          (e) => e.TipoFacturable === "PF"
        );

        setExportOptions((prevExportOptions) => ({
          ...prevExportOptions,
          PF: hasPF,
          CDPF: hasPF,
        }));
      })
      .catch((error) => {
        if (error.code !== 401)
          toast.error("Error al obtener tabla resumen: " + error.msg?.Message);
        API.DEVELOP && console.log(error);
      })
      .finally(() => setLoading(false));
  }, [areaSelected, exerciseSelected]);

  /** carga lista de unidades de negocio */
  const loadBusinessUnitList = () => {
    setLoading(true);
    
    API.obtenerLista({ Lista: "UnidadesNegocio" })
      .then((result) => {
        const bussinesUnitList = result.Valores.map((item) => {
          return { label: item.Etiqueta, value: item.Valor };
        });
        setBusinessUnitList(bussinesUnitList);               
      })
      .catch((e) =>
        toast.error(`No se ha podido cargar la lista de unidades de negocio`)
      )
      .finally(() => setLoading(false));
  };

  const callAreaList = useCallback(() => {
    setLoading(true);
    const dataSend = {
      Lista: "AreaComprometidos",
      ListaRelacional: {
        NombreLista: "UnidadesNegocio",
        IdEntidadRelacional: businessSelected.value,
      },
    };
    API.obtenerLista(dataSend)
      .then((result) => {
        const data = result.Valores.map((e) => {
          return { label: e.Etiqueta, value: e.Valor };
        });
        setAreaList(data);
      })
      .catch((e) => toast.error(`No se ha podido cargar la lista de área`))
      .finally(() => setLoading(false));
  }, [businessSelected.value]);

  const callExerciseList = useCallback(() => {
    setLoading(true);
    const dataSend = {
      Lista: "EjecicioArea",
      ListaRelacional: {
        NombreLista: "AreaComprometidos",
        IdEntidadRelacional: areaSelected.value,
      },
    };
    API.obtenerLista(dataSend)
      .then((result) => {
        const data = result.Valores.map((e) => {
          return { label: e.Etiqueta, value: e.Valor };
        });
        setExerciseList(data);
      })
      .catch((e) => toast.error(`No se ha podido cargar la lista de ejercicio`))
      .finally(() => setLoading(false));
  }, [areaSelected.value]);

  const callStateOTList = () => {
    setLoading(true);
    const dataSend = { Lista: "EstadosTrazabilidadInversa" };
    API.obtenerLista(dataSend)
      .then((result) => {
        const OTStateList = result.Valores.map((item) => {
          return { label: item.Etiqueta, value: item.Valor };
        });
        setStateOTList(OTStateList);
      })
      .catch((e) =>
        toast.error(`No se ha podido cargar la lista de unidades de negocio`)
      )
      .finally(setLoading(false));
  };
  const callSociedadesList = () => {
    setLoading(true);
    const dataSend = {
      Lista: "SociedadAuxiliar",
      ListaRelacional: {
        NombreLista: "UnidadesNegocio",
        IdEntidadRelacional: businessSelected.value,
      },
    }
    API.obtenerLista(dataSend)
      .then((result) => {
        const SociedadList = result.Valores.map((item) => {
          return { label: item.Etiqueta, value: item.Valor };
        });
        setSociedadList(SociedadList);
      })
      .catch((e) =>
        toast.error(`No se ha podido cargar la lista de sociedades`)
      )
      .finally(setLoading(false));
  };


  const loadFamiliaList = async () => {
    try {
      const res = await getFamiliasFromIONPartidas(areaSelected.value);
      setFamiliaList(res);

    }
    catch (error) {
       const msg = error.msg?.Message || "Error desconocido del servidor";
      toast.error(`Error al cargar Familias\n${msg}`);
    }
  };

  const loadConceptoList = async (familia) => { 
    setConceptoList([])

    const areaId = areaSelected?.value;
    
    if (!familia || !areaId) return;

    try {
      const res = await getConceptosByFamilia(familia, areaId);
      setConceptoList(res);

    } catch (error) {      
      const msg = error.msg?.Message || "Error desconocido del servidor";
      toast.error(`Error al cargar Conceptos\n${msg}`);
    }
  };
  
  useEffect(() => {

    const filters = loadIONEngagedFiltersFromLocalStorage();

     if (filters) {
          setBussinesSelected(filters.UnidadNegocio); 
          setAreaSelected(filters.AreaDepartamento); 
          setExerciseSelected(filters.Ejercicio); 
          setExercise(filters.Ejercicio.value);
          setArea(filters.AreaDepartamento.value);      
    }

    loadBusinessUnitList();
    callStateOTList();
  }, []);

  useEffect(() => {
    if (businessSelected?.value) {
      callAreaList();
      callSociedadesList();
    }
  }, [businessSelected, callAreaList]);

  useEffect(() => {
    if (areaSelected?.value) {
      callExerciseList();
    }
  }, [areaSelected, callExerciseList]);

  useEffect(() => {
    if (
      businessSelected?.value &&
      areaSelected?.value &&
      exerciseSelected?.value
    ) {
      setDisabledApplyBTN(false);
      setDisabledLoadExpensesTemplateBTN(false);
    }
  }, [
    businessSelected?.value,
    areaSelected?.value,
    exerciseSelected?.value,
    setDisabledApplyBTN,
    setDisabledLoadExpensesTemplateBTN,
  ]);

  useEffect(() => {
    if (
      !businessSelected?.value ||
      !areaSelected?.value ||
      (!exerciseSelected?.value && disabledApplyBTN === false)
    )
      setDisabledApplyBTN(true);
    setDisabledLoadExpensesTemplateBTN(true);
  }, [
    businessSelected?.value,
    areaSelected?.value,
    exerciseSelected?.value,
    setDisabledApplyBTN,
    disabledApplyBTN,
    setDisabledLoadExpensesTemplateBTN,
  ]);

  useEffect(() => {
    if (
      (suplierFilter?.value === "" || 
      suplierFilter?.value === undefined) &&
      (stateOT?.value === "" ||
      stateOT?.value === undefined) &&
      (numberOT === "" ||
      numberOT === undefined) &&
      (sociedad?.value === "" ||
      sociedad?.value === undefined) &&
      (fecComprDesde === "" ||
      fecComprDesde === undefined) &&
      (fecComprHasta === "" ||
      fecComprHasta === undefined) &&
      (facturado?.value === "" ||
      facturado?.value === undefined) &&
      (validado?.value === "" ||
      validado?.value === undefined) &&
      (exportado?.value === "" ||
      exportado?.value === undefined) &&
      (familiaSelected?.value === "" ||
      familiaSelected?.value === undefined) &&
      (conceptoSelected?.value === "" ||
      conceptoSelected?.value === undefined) &&
      (numeroFacturable === "" ||
      numeroFacturable === undefined)
    ){
      setHayFiltroSeleccionado(false);
    } else {
      setHayFiltroSeleccionado(true);
    }
  }, [
    suplierFilter?.value,
    stateOT?.value,
    sociedad?.value,
    numberOT,
    fecComprDesde,
    fecComprHasta,
    facturado?.value,
    validado?.value,
    exportado?.value,
    familiaSelected?.value,
    conceptoSelected?.value,
    numeroFacturable
  ]);

  const getRegisters = useCallback(() => {
    if (
      !!businessSelected?.value &&
      !!areaSelected?.value &&
      !!exerciseSelected?.value
    ) {
      const data = {
        Ejercicio: parseInt(exerciseSelected.value),
        IdArea: areaSelected.value,
        Paginacion: {
          Pagina: page,
          CantidadRegistros: LIST_SIZE,
        },
      };
      if (suplierFilter.value) data.CodigoProveedor = suplierFilter.value;
      if (stateOT.value) data.IdEstadoTrazabilidadInversa = stateOT.value;
      if (numberOT) data.numeracionOT = numberOT;
      if (sociedad.value) data.CodigoSociedad = sociedad.value;
      if (fecComprDesde) data.FechaComprometidoDesde = fecComprDesde;
      if (fecComprHasta) data.FechaComprometidoHasta = fecComprHasta;
      data.Facturado = facturado.value;
      data.Validado = validado.value;
      data.Exportado = exportado.value;

      data.familia = familiaSelected?.value 
      data.concepto = conceptoSelected?.value 
      data.numeroFacturable = numeroFacturable
      setLoading(true);
      API.obtenerComprometidos(data)
        .then((res) => {
          setRegisters(res);
          loadEngagedSummary();
        })
        .catch((error) => {
          console.error(error);
          toast.error("Error al cargar comprometidos");
        })
        .finally(() => setLoading(false));
    }
  }, [
    areaSelected,
    businessSelected,
    exerciseSelected,
    page,
    suplierFilter,
    stateOT,
    numberOT,
    sociedad,
    fecComprDesde,
    fecComprHasta,
    facturado,
    validado,
    exportado,
    familiaSelected,
    conceptoSelected,
    loadEngagedSummary,
    numeroFacturable,
  ]);

  const getMetadataRegisters = () => {
    setLoading(true);
    API.definicionPagina({
      Modulo: "IONComprometido",
      TipoDefinicion: "grilla",
    })
      .then((res) => setMetadataRegisters(res))
      .catch((error) => {
        API.DEVELOP && console.log(error);
        toast.error("Error al cargar metadata del Listado");
      })
      .finally(() => setLoading(false));
  };

  const loadListSection = useCallback(() => {
    getMetadataRegisters();
    getRegisters();
  }, [getRegisters]);

  const onChangeValuesListInput = (fieldId, fieldValue) => {
    const engagedSection = document.getElementById(TABS.label.engaged);
    const billableSection = document.getElementById(TABS.label.billable);
    const listSection = document.getElementById(TABS.label.list);

    const isEngagedSectionOpen = engagedSection.classList.contains("opened");
    const isBillableSectionOpen = billableSection.classList.contains("opened");
    const isListSectionOpen = listSection.classList.contains("opened");

    if (fieldId === "businessUnitSelect") {
      if (!businessSelected?.value || businessSelected?.value !== fieldValue) {
        setAreaSelected({ value: "", label: "" });
        setAreaList([]);
        setExerciseSelected({ value: "", label: "" });
        setExerciseList([]);
        setEngagedFormData({});
        setCargarArchivoComprometidoRevisado({});
        setSuplier({ value: "", label: "" });
        if (isEngagedSectionOpen) {
          engagedSection.click();
        }
        if (isBillableSectionOpen) {
          billableSection.click();
        }
        if (isListSectionOpen) {
          listSection.click();
        }

        setAccessEngagedSection(false);
        setAccessBillableSection(false);
        setAccessListSection(false);

        setSuplierFilter({ value: "", label: "" });
      }
    } else if (fieldId === "areaSelect") {
      if (!areaSelected?.value || areaSelected?.value !== fieldValue) {
        setExerciseSelected({ value: "", label: "" });
        setExerciseList([]);
        setEngagedFormData({});
        setCargarArchivoComprometidoRevisado({});
        setSuplier({ value: "", label: "" });
        if (isEngagedSectionOpen) {
          engagedSection.click();
        }
        if (isBillableSectionOpen) {
          billableSection.click();
        }
        if (isListSectionOpen) {
          listSection.click();
        }

        setAccessEngagedSection(false);
        setAccessBillableSection(false);
        setAccessListSection(false);

        setSuplierFilter({ value: "", label: "" });
      }
    } else if (fieldId === "exerciseSelect") {
      if (!exerciseSelected?.value || exerciseSelected?.value !== fieldValue) {
        setEngagedFormData({});
        setCargarArchivoComprometidoRevisado({});
        setSuplier({ value: "", label: "" });
        if (isEngagedSectionOpen) {
          engagedSection.click();
        }
        if (isBillableSectionOpen) {
          billableSection.click();
        }
        if (isListSectionOpen) {
          listSection.click();
        }

        setAccessEngagedSection(false);
        setAccessBillableSection(false);
        setAccessListSection(false);

        setSuplierFilter({ value: "", label: "" });
      }
    }
  };

  const handleChangeListInput = (fieldId, fieldValue, etiqueta) => {
    if (fieldId === "businessUnitSelect") {
      setBussinesSelected({ value: fieldValue || "", label: etiqueta || "" });
    } else if (fieldId === "areaSelect") {
      setAreaSelected({ value: fieldValue || "", label: etiqueta || "" });
      setArea(fieldValue);
    } else if (fieldId === "exerciseSelect") {
      setExerciseSelected({ value: fieldValue || "", label: etiqueta || "" });
      setExercise(fieldValue);
    }
    onChangeValuesListInput(fieldId, fieldValue);

    setExportOptions({
      PF: false,
      SP: false,
      FD: false,
      NF: false,
      SF: false,
      CDPF: false,
    });
  };

  /**
   * Cambiar los valores de la sección de Comprometido
   * @param {*} value
   * @param {*} prop
   */
  const handleEngagedDataChange = (value, prop) => {
    let auxData = { ...engagedFormData };
    auxData[prop] = value;

    setEngagedFormData(auxData);
  };

  /**
   * llenar valores de la data cunado se carga el fichero
   * @param {*} e
   */
  const handleLoadFileChange = (e) => {
    const idInput = e.target.id;
    const file = e.target.files[0];
    let reader = new FileReader();
    let base64;
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      base64 = reader.result.replace(/^data:.+;base64,/, "");
      let auxData = { ...engagedFormData };
      auxData.engagedFile = base64;
      auxData.engagedFileName = file.name;
      if (idInput === "comprometido") {
        setEngagedFormData(auxData);
      } else {
        setCargarArchivoComprometidoRevisado(auxData);
      }
    };
  };

  /**
   * Abrir popup para cargar archivo
   */
  const openPopUpLoadFile = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx";
    input.id = "comprometido";
    input.onchange = handleLoadFileChange;
    // input.disabledle = showDeleted;
    input.click();
  };

  const openPopUpLoadFileComprometidoRevisado = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx";
    input.id = "comprometido-revisado";
    input.onchange = handleLoadFileChange;
    // input.disabledle = showDeleted;
    input.click();
  };

  /**
   * cargar comprometido
   */
  const handleSendEngaged = () => {
    const dataSend = {
      NombreFichero: engagedFormData.engagedFileName,
      Ejercicio: Number(exercise),
      AreaDepartamento: area,
      DatosArchivoComprometido: engagedFormData.engagedFile,
      Prorrateo: engagedFormData.prorrateo || false,
    };

    setLoading(true);
    API.subirComprometidos(dataSend)
      .then((res) => {
        if (res.Estado === "OK") {
          toast.success("El fichero fue cargado exitosamente");
        } else if (res.Estado === "INFO") {
          toast.info(res.Mensaje);
        } else if (res.Estado === "WARNING") {
          toast.warning("El fichero no tiene el formato correcto");
          handleDownload(res);
        } else if (res.Estado === "KO") {
          toast.error(
            "Ha ocurrido un error en la carga del fichero\n" + res.Mensaje
          );
        }
      })
      .catch((error) => {
        toast.error(error.msg.Message);
      })
      .finally(() => {
        loadEngagedSummary();
        setLoading(false);
      });
  };

  const cargarComprometidoRevisado = () => {
    const dataSend = {
      NombreFichero: cargarArchivoComprometidoRevisado.engagedFileName,
      Ejercicio: Number(exercise),
      AreaDepartamento: area,
      DatosArchivoComprometido: cargarArchivoComprometidoRevisado.engagedFile,
      SaltarValidaciones: engagedFormData.skipValidations,
    };
    setLoading(true);
    API.subirComprometidosRevisados(dataSend)
      .then((res) => {
        if (res.Estado === "OK") {
          toast.success("El fichero fue cargado exitosamente");
        } else {
          toast.error(
            `Ha ocurrido un error en la carga del fichero. ${res.Mensaje}`
          );
        }
      })
      .catch((e) => {
        toast.error(e.msg.Message);
      })
      .finally(() => {
        loadEngagedSummary();
        setLoading(false);
      });
  };

  /**
   * exportar datos comprometidos a excel
   */
  const exportEngagedData = () => {
    const dataSend = {
      Ejercicio: Number(exercise),
      AreaDepartamento: area,
      ExportarAcumulado: !!engagedFormData.exportAmount ? true : false,
      ExportarGestor: !!engagedFormData.exportGestor ? true : false,
      FechaDesdeComprometido: billableDates?.fechaDesde,
      FechaHastaComprometido: billableDates?.fechaHasta,
      Facturado: facturable?.value,
      TipoFacturable: typeBillable?.value,
    };
    setLoading(true);
    API.generarExcelComprometidos(dataSend)
      .then((res) => {
        if (res.Estado === "WARNING") {
          toast.success("Se han exportado los datos correctamente");
          handleDownload(res);
        } else if (res.Estado === "KO") {
          toast.error(res.Mensaje);
        }
      })
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
  };

  const downloadTemplateCargarGastosComprometidos = () => {
    setLoading(true);
    API.generarPlantillaCargarGastosComprometidos()
      .then((res) => {
        if (res.Estado === "OK") {
          handleDownload(res);
        } else {
          throw new Error(res.Mensaje);
        }
      })
      .catch((error) => {
        toast.error(`Error al descargar plantilla\n${error.message || ""}`);
        API.DEVELOP && console.error(error);
      })
      .finally(() => setLoading(false));
  };


  /**
   * boton aplicar abrir campos segun los permisos
   */
  const handleApplyBTN = async () => {

    const engagedAccess = permissions.IONComprometido.Acceso;
    const billableAccess = permissions.IONFacturable.Acceso;
    const listAccess = permissions.ION.Listar;

    await setAccessEngagedSection(engagedAccess);
    await setAccessBillableSection(billableAccess);
    await setAccessListSection(listAccess);

    const engagedSection = document.getElementById(TABS.label.engaged);
    const billableSection = document.getElementById(TABS.label.billable);
    // const listSection = document.getElementById(TABS.label.list);
    if (engagedAccess && !engagedSection.classList.contains("opened")) {
      engagedSection.click();
    }
    if (billableAccess && !billableSection.classList.contains("opened")) {
      billableSection.click();
    }
    setDisabledApplyBTN(true);

    loadFamiliaList()

    loadEngagedSummary();

    setPage(1);

    saveIONEngagedFiltersToLocalStorage()
  };
  
  const handleLoadBillable = () => {
    const dataSend = {
      Ejercicio: Number(exercise),
      AreaDepartamento: area,
      Proveedor: suplier?.value,
    };
    setLoading(true);
    API.marcarFacturables(dataSend)
      .then((response) => {
        if (response.Estado === "OK") {
          toast.success(response.Mensaje);
        } else {
          toast.warning(response.Mensaje);
        }
      })
      .catch((e) => console.error(e))
      .finally(() => {
        loadEngagedSummary();
        setLoading(false);
      });
  };

  /**
   * cambio de proveedor
   * @param {*} val
   */
  const handleSupplierSelect = (id, value) => {
    setSuplier({ value: value.Valor, label: value.Etiqueta });
  };

  /**
   * cambio de proveedor para filtro de listado
   * @param {*} val
   */
  const handleSupplierFilterSelect = (id, value) => {
    setSuplierFilter({ value: value.Valor, label: value.Etiqueta });
  };

  const handleTypeBillableSelect = (id, value) => {
    setTypeBillable({ value: value.Valor, label: value.Etiqueta });
  };

  const handleFacturableSelect = (id, value) => {
    setFacturable({ value: value.Valor, label: value.Etiqueta });
  };

  const handleBillableDatesChange = (name, value) => {
    setBillableDates((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const exportSelected = () => {
    const data = {
      Ejercicio: Number(exercise),
      AreaDepartamento: area,
      PF: exportOptions.PF,
      SP: exportOptions.SP,
      FD: exportOptions.FD,
      NF: exportOptions.NF,
      SF: exportOptions.SF,
      CDPF: exportOptions.CDPF && exportOptions.PF,
    };
    if (suplier.value) data.CodigoProveedor = suplier.value;

    setLoading(true);
    API.generarExcelFacturacion(data)
      .then((res) => {
        if (res.Estado === "OK") {
          toast.success("Fichero descargado");
          handleDownload(res);
        } else if (res.Estado === "INFO") {
          toast.info(res.Mensaje);
          if (res.FicheroData) handleDownload(res);
        } else if (res.Estado === "KO") {
          toast.error(res.Mensaje);
          if (res.FicheroData) handleDownload(res);
        }
      })
      .catch((e) => {
        toast.error("Ha ocurrido un error al exportar");
        console.error(e);
      })
      .finally(() => {
        loadEngagedSummary();
        setLoading(false);
      });
  };

  const handleStateOTSelect = (id, value) => {
    setStateOT({ value: value.Valor, label: value.Etiqueta });
  };

  const handleChangeSociedad = (_, value) => {
    setSociedad({ value: value.Valor, label: value.Etiqueta });
  };

  const recalcularProrrateos = () => {
    const data = {
      IdAreaDepartamento: areaSelected.value,
      Ejercicio: parseInt(exerciseSelected.value) || 0,
    };

    setLoading(true);
    API.actualizacionProrrateo(data)
      .then((res) => {
        if (res.Estado === "OK") {
          toast.success("Prorrateos recalculados");
        } else if (res.Estado === "KO") {
          toast.error(res.Mensaje);
        }
      })
      .catch((e) => {
        toast.error("Ha ocurrido un error al recalcular prorrateos");
        console.error(e);
      })
      .finally(() => {
        loadEngagedSummary();
        setLoading(false);
      });
  };

  const actualizarSeleccionado = (id, seleccionado) => {
    const nuevaData = registers.map(row =>
      row.ot === parseInt(id)
        ? { ...row, seleccionado: seleccionado }
        : { ...row } // Clonamos todos los objetos para mantener consistencia
    );
    setRegisters(nuevaData);
  };

  const getCantidadItemsPorProcesar = async (tipo) => {
    const data = getFiltrosSeleccionados(tipo);
    const resp = await API.obtenerCantidadComprometidos(data);
    return resp.cantidad; 
  }
  
  const getFiltrosSeleccionados = (tipo) => {
    const data = {
      Tipo: tipo,
      Ejercicio: parseInt(exerciseSelected.value),
      IdArea: areaSelected.value,
    };

    if (suplierFilter.value) data.CodigoProveedor = suplierFilter.value;
    if (stateOT.value) data.IdEstadoTrazabilidadInversa = stateOT.value;
    if (numberOT) data.numeracionOT = numberOT;
    if (sociedad.value) data.CodigoSociedad = sociedad.value;
    if (fecComprDesde) data.FechaComprometidoDesde = fecComprDesde;
    if (fecComprHasta) data.FechaComprometidoHasta = fecComprHasta;
    data.Facturado = facturado.value;
    data.Validado = validado.value;
    data.Exportado = exportado.value;

    data.familia = familiaSelected?.value;
    data.concepto = conceptoSelected?.value; 

    return data;
  }

  const ACCORDION_METADATA = [
    {
      label: TABS.label.engaged,
      access: accessEngagedSection,
      content: (
        <EngagedSectionComponent
          loading={loading}
          engagedFormData={engagedFormData}
          setEngagedFormData={setEngagedFormData}
          openPopUpLoadFile={openPopUpLoadFile}
          permissions={permissions}
          exercise={exercise}
          area={area}
          handleSendEngaged={handleSendEngaged}
          handleEngagedDataChange={handleEngagedDataChange}
          exportEngagedData={exportEngagedData}
          cargarArchivoComprometidoRevisado={cargarArchivoComprometidoRevisado}
          openPopUpLoadFileComprometidoRevisado={
            openPopUpLoadFileComprometidoRevisado
          }
          cargarComprometidoRevisado={cargarComprometidoRevisado}
          totalStatusSummary={totalStatusSummary}
          recalcularProrrateos={recalcularProrrateos}
          isAdminIon={isAdminIon}
          isCoordinadorIon={isCoordinadorIon}
          typeBillable={typeBillable}
          handleTypeBillableSelect={handleTypeBillableSelect}
          billableDates={billableDates}
          handleBillableDatesChange={handleBillableDatesChange}
          listTypeFacturable={listTypeFacturable}
          facturable={facturable}
          handleFacturableSelect={handleFacturableSelect}
          listFacturable={listFacturable}
        />
      ),
    },
    {
      label: TABS.label.billable,
      access: accessBillabeSection,
      content: (
        <BillableSectionComponent
          loading={loading}
          suplier={suplier}
          handleSupplierSelect={handleSupplierSelect}
          area={area}
          handleLoadBillable={handleLoadBillable}
          permissions={permissions}
          exportOptionsState={{ exportOptions, setExportOptions }}
          handleExportSelected={exportSelected}
          totalStatusSummary={totalStatusSummary}
        />
      ),
    },
    {
      label: TABS.label.list,
      access: accessListSection,
      content: (
        <ListSectionComponent
          loading={loading}
          suplierFilter={suplierFilter}
          handleSupplierFilterSelect={handleSupplierFilterSelect}
          area={area}
          metadataRegisters={metadataRegisters}
          registers={registers}
          page={page}
          setPage={setPage}
          listSize={LIST_SIZE}
          stateOT={stateOT}
          stateOTList={stateOTList}
          handleStateOTSelect={handleStateOTSelect}
          numberOT={numberOT}
          handleChangeNumberOT={(_, value) => setNumberOT(value)}
          setModalRequest={setModalRequest}
          setSelected={setSelected}
          actualizarSeleccionado={actualizarSeleccionado}
          sociedad={sociedad}
          handleChangeSociedad={handleChangeSociedad}
          sociedadList={sociedadList}
          fecComprDesde={fecComprDesde}
          setFecComprDesde={setFecComprDesde}
          fecComprHasta={fecComprHasta}
          setFecComprHasta={setFecComprHasta}
          facturado={facturado}
          setFacturado={setFacturado}
          validado={validado}
          setValidado={setValidado}
          exportado={exportado}
          setExportado={setExportado}
          permissions={permissions}
          conceptoList={conceptoList}
          familiaList = {familiaList}
          familiaSelected={familiaSelected}
          conceptoSelected={conceptoSelected}
          engagedFormData={engagedFormData}
          handleChangeFamilia={handleChangeFamilia}
          handleChangeConcepto={handleChangeConcepto}
          showValidarComprometidos={showValidarComprometidos}
          showDesValidarComprometidos={showDesValidarComprometidos}
          showFacturarComprometidos={showFacturarComprometidos}
          showExportarComprometidos={showExportarComprometidos}
          hayFiltroSeleccionado={hayFiltroSeleccionado}
          seleccionFiltro={seleccionFiltro}
          setSeleccionFiltro={setSeleccionFiltro}
          numeroFacturable={numeroFacturable}
          setNumeroFacturable={setNumeroFacturable}
        />
      ),
    },
  ];

  return {
    ACCORDION_METADATA,
    loading,
    setArea,
    setExercise,
    disabledApplyBTN,
    setDisabledApplyBTN,
    disabledLoadExpensesTemplateBTN,
    setDisabledLoadExpensesTemplateBTN,
    handleApplyBTN,
    downloadTemplateCargarGastosComprometidos,
    setEngagedFormData,
    setCargarArchivoComprometidoRevisado,
    businessSelected,
    businessUnitList,
    handleChangeListInput,
    areaSelected,
    areaList,
    exerciseList,
    exerciseSelected,
    loadListSection,
    visibleModal,
    visibleAlert,
    messageAlert,
    selected,
    comprometido,
    setComprometido,
    deleteComprometido,
    editComprometido,
    addComprometido,
    listsModalComprometido,
    cerrarModal,
    cerrarModalAlert,
    metadataTable,
    setMetadataTable,
    permissions,
    procesarSeleccion,
  };
};

export default useIONEngagedPage;
